<template>
  <div class="xm-home">
    <mm-spinner :visible="loading" />
    <div class="home-space">
      <h1
        class="title"
        v-t="'home.title'"
      />
      <a
        v-if="isClientActive && isJapan"
        class="jump-text"
        href="https://io.okki.ai"
        target="_blank"
      >Back to Homepage</a>
      <span v-if="isAdmin && !isTaiwanClient && !isJapan">
        <ui-switch
          v-model="openFlag"
          :on-value="1"
          :off-value="0"
          :disabled="!isClientActive"
          @change="setServiceAuthorize"
        />
        <span class="text">使用销售服务</span>
        <ui-tooltip popper-class="account-tooltip-popper">
          <span class="help-icon" />
          <div slot="content">
            销售服务是与用户订购小满软件相关的服务，该服务由小满指定的销售代理商提供，不同于小满科技提供的软件服务。用户选择使用销售服务的，将同意小满科技向销售代理商提供用户订购、使用小满软件的信息以及小满科技为用户提供软件服务的信息；用户拒绝并关闭“使用销售服务”权限的，小满科技将停止向销售代理商提供前述信息，销售代理商也将停止向用户提供销售服务，而停止提供销售服务可能会影响小满软件激活、交付或使用过程中所产生问题的高效解决。用户与小满科技关于销售服务的约定详见
            <a
              href="https://www.okki.com/zh-cn/after-service"
              target="_blank"
            >《销售服务合同》</a>
          </div>
        </ui-tooltip>
      </span>
    </div>

    <my-product v-if="!loading" />
  </div>
</template>
<script>
  import Store from '@store'
  import { mapState, mapGetters } from 'vuex'
  import MyProduct from './components/MyProduct'
  import { Switch, Tooltip } from 'amumu-ui'
  import homeApi from '@api/home'

  export default {
    name: 'XmHome',
    components: {
      MyProduct,
      'ui-switch': Switch,
      'ui-tooltip': Tooltip
    },
    data() {
      return {
        openFlag: 1,
        loading: true,
      }
    },
    async created() {
      await Store.dispatch('home/fetchProductInfo')
      this.loading = false
    },
    computed: {
      ...mapState("main", {
        isClientActive: state => state.isClientActive,
      }),
      ...mapGetters("main", ["isAdmin", "isTaiwanClient"]),
      isJapan() {
        return window.location.host.includes('okki.ai')
      },
    },
    watch: {
      isClientActive (val) {
        if (val) {
          this.getServiceFlag()
        }
      }
    },
    mounted() {
      this.isClientActive && this.getServiceFlag()
    },
    methods: {
      setServiceAuthorize() {
        const formData = new FormData()
        formData.append('open_sync_flag', this.openFlag)
        homeApi.fetchCrmOpenServiceSetting(formData)
      },
      getServiceFlag() {
        homeApi.getServiceFlag().then(data => {
          this.openFlag = Number(data.open_sync_flag)
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .xm-home{
    @extend %block-box;
    position: relative;
    padding-top: 48px;
    padding-bottom: 48px;
  }
  .title{
    margin-bottom: 30px;
  }
  .home-space {
    position: relative;
    display: flex;
    justify-content: space-between;
  }
  .account-tooltip-popper {
    max-width: none;
    width: 430px;
  }

  .text {
    margin-right: 8px;
    margin-left: 8px;
    vertical-align: middle;
  }
  
  .jump-text {
    position: absolute;
    top: 3px;
    left: 140px;
  }
</style>


